import { listOptionsItems } from '../../../data/data';
import { ClassNameProps, Item } from '../../../types/types';

const ListOptions: React.FC<ClassNameProps> = ({ className }) => {
  return (
    <>
      <ul className={className}>
        {listOptionsItems.map((item: Item) => (
          <li key={item.id} className={`${className}__item`}>
            <div className={`${className}__wrap`}>
              {item.svg}
              <span className={`text-medium`}>{item.title}</span>
              <span className={`${className}__color text-medium`}>
                {item.text}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};
export default ListOptions;
